"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Component = _interopRequireDefault(require("./Component.js"));
var _Settings = _interopRequireDefault(require("./Settings.js"));
var _Thumbnail = _interopRequireDefault(require("./Thumbnail.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = {
  handle: 'default',
  label: 'Solid Color',
  component: _Component["default"],
  settingsComponent: _Settings["default"],
  thumbnail: _Thumbnail["default"]
};